import React, { useState, useEffect } from "react";
// styles
import "../pages.css";
// components
import Filtros from './Filtros';
import TransitionModal from "../../components/utils/modals/Modals";
import ServerPaginationGrid from "../../components/utils/grid/PaginatedGrid";
import CircularIndeterminate from '../../components/utils/spinner/Spinner';
// consts
import { endUser as titles } from "../../consts/titulos-de-tablas";
import { modalsInfoUsuarioContacto as infoModal } from "../../consts/Modals-info";
// services
import { endUserGet } from '../../services/hooli-services/EndUser/EndUserGet';
import { registrosGet } from "../../services/hooli-services/Registros/RegistrosGet";
import { usuarioStatusGet } from "../../services/hooli-services/EndUser/UsuarioStatusGet";
// recoil
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil';
import { userCredentials, rowSelected, formData } from '../../recoilState/GlobalState';

export default function EndUser() {
  const [registros, setRegistros] = useState([]);
  const [userStatus, setUserStatus] = useState([]);
  const [filtros, setFiltros] = useState({ registro: 'todos', documento: '', apellido: '' });
  const [modalCargando, setModalCargando] = useState(true);
  const [procede, setProcede] = useState();
  const [forceUpload, setForceUpload] = useState(false);
  const [row, setRow] = useRecoilState(rowSelected);
  const credentials = useRecoilValue(userCredentials);
  const setFormInfo = useSetRecoilState(formData);

  const retrieveEndUsers = async (page = 0, pageLen = 10, cred = credentials) => {
    
    const params = {
      "usuarioApellidos": filtros.apellido,
      "usuarioNroDeDocumento": filtros.documento.replace(/\./g, ''),
      "registroId": filtros.registro === 'todos' ? null : filtros.registro,
      "page": page + 1,
      "pageLen": pageLen
    };
    const payload = { ...cred, params };
    const data = await endUserGet(payload);

    return {
      rows: data?.data?.map((item) => ({
        id: item.usuarioId,
        aprobados: item.cuentaOK,
        enEspera: item.cuentaBO,
        rechazados: item.cuentaRE,
        [titles[0]]: item.usuarioApellidos,
        [titles[1]]: item.usuarioNombres,
        [titles[2]]: item.tipoDeDocumentoCod,
        [titles[3]]: item.usuarioNroDeDocumento,
        [titles[4]]: item.usuarioSexo,
        [titles[5]]: item.usuarioFechaAlta,
        [titles[6]]: item.usuarioCVU,
        [titles[7]]: item.usuarioCVUAlias,
        [titles[8]]: item.usuarioStatusRegistro,
        [titles[9]]: item.usuarioStatusOperativo,
        [titles[10]]: item.usuarioMail,
        [titles[11]]: item.usuarioTelefonoCelular,
      })),
      rowCount: data?.total ?? 0
    };
  };

  const retrieveRegisters = async () => {
    const payload = { ...credentials, tipoRegistroCod: "E" };
    const data = await registrosGet(payload);
    setRegistros(data);
  };

  const retrieveUserStatus = async () => {
    const payload = {
      ...credentials,
      params: {
        usuarioUID: row.status ? row.row.id : '',
        rolCod: "E"
      }
    };
    setModalCargando(true);
    const data = await usuarioStatusGet(payload);
    setUserStatus(data);
    setModalCargando(false);
  };

  useEffect(() => {
    if (Object.keys(credentials).length > 0) retrieveRegisters();
  }, [credentials]);

  useEffect(() => {
    if (Object.keys(credentials).length > 0 && row.row?.id) retrieveUserStatus();
  }, [credentials, row]);

  useEffect(() => setRow({ status: false }), []);

  const handleClick = ({ action, procede }) => {
    if (action) setFormInfo(infoModal[action]);
    setProcede(procede || undefined);
  };

  const refreshGrid = () => setForceUpload(prev => !prev);

  return (
    <main className="container">
      <TransitionModal
        procede={procede}
        setProcede={setProcede}
        userStatus={userStatus}
        cargando={modalCargando}
        updateList={refreshGrid}
        updateModalList={retrieveUserStatus}
      />

      <Filtros
        filtros={filtros}
        setFiltros={setFiltros}
        cargando={false}
        registros={registros}
        updateList={retrieveEndUsers}
        setProcede={setProcede}
        handleClick={handleClick}
      />

      <div className="row-grid">
        <ServerPaginationGrid
          titles={titles}
          updateList={retrieveEndUsers}
          filtros={filtros}
          forceUpload={forceUpload}
        />
      </div>
    </main>
  );
}